import { render } from "./Vogue.svg?vue&type=template&id=34243cb5"
const script = {}
script.render = render

export default script